export default function homeAboutInit() {

    let $aboutStats = $('.about-stats');

    $aboutStats.each(function (index, element) {
        let $stats = $(element),
            $box = $('.about-stats__box', $stats);
        if ($box.text().length > 3) {
            $stats.toggleClass('about-stats--small', true);
        }
        else {
            $stats.toggleClass('about-stats--small', false);
        }
    });

    return null;
}